import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { KeyRound, Mail } from "lucide-react";
import logoFull from "@/assets/logo-full-new.png";
import MaintenanceShowcase from "@/components/MaintenanceShowcase";

const Maintenance = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("We are currently performing scheduled maintenance. Please check back soon.");

  useEffect(() => {
    const fetchMaintenanceMessage = async () => {
      const { data } = await supabase
        .from("maintenance_settings")
        .select("message")
        .single();
      
      if (data?.message) {
        setMessage(data.message);
      }
    };

    fetchMaintenanceMessage();
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-start bg-background p-6 pt-12 relative">
      <button
        onClick={() => navigate('/admin-login')}
        className="absolute top-4 right-4 p-2 rounded-full hover:bg-muted 
                   opacity-40 hover:opacity-100 transition-opacity"
        aria-label="Admin login"
        title="Admin login"
      >
        <KeyRound className="w-6 h-6 text-muted-foreground" />
      </button>
      
      <div className="text-center max-w-2xl mb-8">
        <img 
          src={logoFull} 
          alt="PTA Hub" 
          className="mx-auto mb-6 h-20 w-auto"
          fetchPriority="high"
          width={206}
          height={80}
        />
        <h1 className="text-3xl font-bold mb-4 text-foreground">
          Coming Soon...
        </h1>
        <p className="text-lg text-muted-foreground whitespace-pre-wrap">
          {message}
        </p>
      </div>

      <MaintenanceShowcase />

      {/* Early Access CTA */}
      <div className="mt-12 mb-8 max-w-2xl text-center">
        <div className="bg-primary/10 border border-primary/20 rounded-xl p-6 md:p-8">
          <h2 className="text-xl md:text-2xl font-semibold text-foreground mb-3">
            🚀 Early Access for PTAs
          </h2>
          <p className="text-muted-foreground mb-4 leading-relaxed">
            We're looking for a small number of PTAs to have early access for a limited time — 
            <span className="font-semibold text-foreground"> completely free</span>. 
            Help us by providing feedback, spotting any issues, and shaping the platform. 
            If this sounds like your PTA, we'd love to hear from you!
          </p>
          <a
            href="mailto:info@ptahub.co.uk?subject=Early%20Access%20Request"
            className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-lg font-semibold hover:bg-primary/90 transition-colors"
          >
            <Mail className="w-5 h-5" />
            info@ptahub.co.uk
          </a>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
